import axios from "axios";

const ApiSystemSettingAuth = {
  get() {
    return axios.get("/api/v1/system-settings/authentication");
  },

  update(payload) {
    return axios.put("/api/v1/system-settings/authentication", payload);
  },
};

export default ApiSystemSettingAuth;